import { render, staticRenderFns } from "./CreatNewTeam.vue?vue&type=template&id=8c20eb4a&scoped=true&"
import script from "./CreatNewTeam.vue?vue&type=script&lang=js&"
export * from "./CreatNewTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c20eb4a",
  null
  
)

export default component.exports